/**
 * @fileoverview Hook for fetching ICE servers
 *
 * @example
 * // Usage:
 * import { useICEServers } from './useICEServers'
 *
 * function Component() {
 *   const iceServers = useICEServers()
 *   // ...
 * }
 */

import axios from 'axios'
import { useMemo, useState } from 'react'
import config from '../config'

/**
 * @function useICEServers
 * @description Hook for fetching ICE servers
 * @returns {RTCIceServer[]} The ICE servers
 */
export function useICEServers() {
    const [iceServers, setIceServers] = useState<RTCIceServer[]>([])

    useMemo(() => {
        axios.get(config.webRTC.urls.ice).then(({ data: iceServers }) => {
            const filteredIce = iceServers.filter((ice: RTCIceServer) => {
                let tcp = false
                ;(ice.urls as string[]).filter((url) => {
                    tcp = url.indexOf('transport=tcp') >= 0
                })
                return tcp
            })
            setIceServers(filteredIce)
        })
    }, [])

    return iceServers
}
